import { LatLngLiteral } from '@agm/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-route-tracker',
  templateUrl: './route-tracker.component.html',
  styleUrls: ['./route-tracker.component.css']
})
export class RouteTrackerComponent implements OnInit {
  @Input() trip;
  @Output() onCloseModal = new EventEmitter<any>();

  latitude = 35.125801;
  longitude = -117.9859038;
  centerLatitude = this.latitude;
  centerLongitude = this.longitude;
  zoom = 18;
  geoCoder;
  address;
  searchedLocation;
  origin = { lat: 0.00000, lng: 0.00000 };
  destination = { lat: 0.00000, lng: 0.00000 };
  trails = [];
  buttonLabel = 'Copy Trail';

  constructor(
    private assignTripService: AssigTripsService
  ) { }

  ngOnInit() {
    this.origin = {
      lat: this.trip.jobOriginLatitude,
      lng: this.trip.jobOriginLongitude
    };
    this.destination = {
      lat: this.trip.jobDestinationLatitude,
      lng: this.trip.jobDestinationLongitude
    };
    this.getTrails();
  }

  getTrails(){
    this.trails.unshift(this.origin);
    this.assignTripService.getTrailsById(this.trip._id).subscribe(data=>{
      if(data && data.trail && data.trail.length > 0) {
        const coordinates = data.trail[0].trails.map(coord => {
          const [lat, lng] = coord.split(',').map(Number);
          return { lat, lng };
        });
        this.trails = [...this.trails,...coordinates];
      }
      this.trails.push(this.destination);
    })
  }


  mapReady(map) {
    const bounds = new google.maps.LatLngBounds();
    this.trails.forEach(coord => {
      bounds.extend(new google.maps.LatLng(coord.lat, coord.lng));
    });
    map.fitBounds(bounds);
  }


  centerChanged(coords: LatLngLiteral) {
    this.centerLatitude = coords.lat;
    this.centerLongitude = coords.lng;
  }

   async copyToClipboard(trails) {
    try {
      await navigator.clipboard.writeText(trails.map(coord => `${coord.lat},${coord.lng}`).join('\n'));
      const original = this.buttonLabel;
      this.buttonLabel = 'Copied';
      setTimeout(() => {
        this.buttonLabel = original;
      }, 1000);
    } catch (err) {
      console.error('Copy failed:', err);
    }
   }

  closeModal() {
    this.onCloseModal.emit();
  }
}
